import { useNavigate } from "react-router-dom";
import categories from "../../utils/categories";
import logo from '../../assets/digikorestudios.png'
import { Search, X } from "lucide-react";
import { useState } from "react";

const CategoriesPage = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const handleCategoryClick = (categoryName) => {
    navigate(`/jingle-collection/${categoryName}`);
  };

  const filteredCategories = (categories || []).filter((category) => {
    const search = searchQuery.toLocaleLowerCase()
    const catrgoryName = category.name?.toLowerCase().trim() || "";
    const matchesSearch = catrgoryName.includes(search)

    return matchesSearch
  })

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-amber-50 overflow-hidden relative">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-r from-orange-200 to-amber-200 rounded-full blur-3xl opacity-30 animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-r from-amber-200 to-orange-200 rounded-full blur-3xl opacity-30 animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/4 w-60 h-60 bg-gradient-to-r from-orange-100 to-amber-100 rounded-full blur-2xl opacity-40 animate-pulse delay-500"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 py-12">
        {/* Enhanced Header with Animation */}
        <div className="flex flex-col justify-center items-center text-center mb-16 max-md:mb-4 pt-12 ">
          <img src={logo} className=" w-23 h-14 mb-4" />
          <h1 className="text-4xl max-md:text-3xl font-bold bg-gradient-to-r from-orange-600 via-amber-600 to-orange-600 bg-clip-text text-transparent mb-4 animate-fade-in bg-size-200 animate-gradient pb-1.5 ">
            Jingles Collection
          </h1>
          <p className="text-gray-600 text-xl max-w-2xl mx-auto max-md:text-base animate-slide-up leading-relaxed">
            Immerse yourself in a world of melodies. Discover your favorite tunes across different genres and moods.
          </p>


          <div className="w-full max-w-2xl mx-auto mt-2 animate-slide-up delay-300">
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-orange-400 to-amber-500 rounded-2xl blur-lg opacity-0 group-hover:opacity-30 transition-all duration-500"></div>

              <div className="relative flex items-center bg-white/90 backdrop-blur-sm rounded-2xl border border-orange-200/50 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
                <div className="pl-5 pr-3">
                  <Search className="w-5 h-5 text-gray-400" />
                </div>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search categories by name"
                  className="w-full py-4 max-md:py-2 px-2 max-md:px-1 bg-transparent outline-none text-gray-700 placeholder-gray-400 text-lg"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Enhanced Categories Grid */}
        {
          filteredCategories.length > 0 ? (
            <div className="grid max-md:grid-cols-2 xl:grid-cols-6 gap-8 max-w-7xl mx-auto">
              {filteredCategories.map((category, index) => (
                <div
                  key={category.id}
                  onClick={() => handleCategoryClick(category.name)}
                  className="group relative rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 cursor-pointer transform hover:-translate-y-3 border border-orange-100/50 hover:border-orange-200 animate-fade-in-up overflow-hidden"
                  style={{ animationDelay: `${index * 100}ms` }}
                >
                  {/* Image as Background of Entire Card */}
                  <img
                    src={category.image}
                    alt={category.name}
                    className="absolute inset-0 w-full h-full object-cover filter group-hover:brightness-110 transition-all duration-300"
                  />

                  {/* Dark Overlay for Better Readability */}
                  <div className="absolute inset-0 bg-gradient-to-br from-black/40 via-black/30 to-black/20 group-hover:from-black/50 group-hover:via-black/40 group-hover:to-black/30 transition-all duration-300"></div>

                  {/* Hover Glow Effect */}
                  <div className="absolute inset-0 bg-gradient-to-br from-orange-500/0 via-amber-500/0 to-orange-500/0 group-hover:from-orange-500/10 group-hover:via-amber-500/15 group-hover:to-orange-500/10 transition-all duration-500 rounded-2xl"></div>

                  {/* Shine Effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent transform -skew-x-12 group-hover:animate-shine"></div>

                  <div className="p-6 relative z-10 h-full flex flex-col justify-between min-h-[150px] max-md:min-h-[150px]">
                    {/* Top Content */}
                    <div className="text-center">
                      <h3 className="text-xl max-md:text-l font-bold text-white drop-shadow-2xl group-hover:text-orange-50 transition-all duration-300 tracking-tight mb-4 relative">
                        <span className="relative z-10 bg-gradient-to-r from-white to-orange-100 bg-clip-text text-transparent">
                          {category.name}
                        </span>
                        {/* Text Background for Better Readability */}
                        <span className="absolute inset-0 bg-black/40 blur-md rounded-lg transform scale-110"></span>
                      </h3>
                    </div>

                    {/* Bottom Content - Explore Button */}
                    <div className="text-center">
                      <div className="opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-500">
                        <div className="inline-flex items-center space-x-1 bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white px-2 py-1 rounded-full text-xs font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 group/btn relative overflow-hidden backdrop-blur-sm">
                          <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent transform -skew-x-12 group-hover/btn:animate-shine"></div>
                          <span className="relative">Explore Collection</span>
                          <svg
                            className="w-4 h-4 transform group-hover/btn:translate-x-1 transition-transform duration-300 relative"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 5l7 7-7 7"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Outer Glow */}
                  <div className="absolute inset-0 bg-gradient-to-r from-orange-400 to-amber-500 rounded-2xl blur-lg opacity-0 group-hover:opacity-30 transition-all duration-500 -z-10 group-hover:scale-105"></div>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex justify-center items-center h-64">
              <p className="text-gray-600 text-xl max-w-2xl mx-auto max-md:text-base animate-slide-up leading-relaxed">
                No categories found
              </p>
            </div>
          )
        }

        {/* Enhanced Footer */}
        <div className="text-center mt-20 animate-fade-in delay-1000 pb-12">
          <div className="inline-flex items-center space-x-3 bg-white/90 backdrop-blur-sm px-6 py-4 rounded-2xl border border-orange-200/50 shadow-lg hover:shadow-xl transition-all duration-300 group">
            <span className="text-2xl animate-bounce">🎧</span>
            <p className="text-gray-600 text-base font-medium">
              Click on any category to explore the music collection
            </p>
          </div>
        </div>

        {/* Copyright Notice - Added here for prominence */}
          <div className=" mb-8 animate-slide-up delay-200">
            <div className="bg-gradient-to-r from-amber-50 to-orange-50 border-l-4 border-amber-500 rounded-lg p-4 max-w-4xl mx-auto shadow-sm">
              <div className="flex items-start">
                <div className="flex-shrink-0 mr-3">
                  <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                  </div>
                </div>
                <div className="text-left">
                  <p className="text-amber-800 font-medium mb-1">Important Notice</p>
                  <p className="text-amber-700 text-sm">
                    All sample jingles are provided solely for reference purposes. We do not copy, reproduce, or imitate any existing jingles. Each jingle presented is an original work with its own unique composition and lyrics, and all jingles are protected by their respective copyrights.
                  </p>
                </div>
              </div>
            </div>
          </div>

      </div>

      <footer className="w-full bg-gray-100 text-center py-4 text-sm text-gray-600 mt-10">
        <p>
          For contact and support:{" "}
          <a href="mailto:prapti@digikore.com" className="text-blue-600 hover:underline">
            prapti@digikore.com
          </a>
        </p>
        <p className="mt-1">© 2026 Digikore Studios Limited</p>
      </footer>
    </div >
  );
};

export default CategoriesPage;